import { Pipe, PipeTransform } from "@angular/core";
import { PLANNED, PRE_PLANNED } from "../models/status-type.interface";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "status"
})
export class StatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: any, ...args: any[]): string {
    let stringStatus = "";

    if (value === PLANNED) {
      stringStatus = this.translateService.instant("STATUS.PLANNED");
    }

    if (value === PRE_PLANNED) {
      stringStatus = this.translateService.instant("STATUS.PRE_PLANNED");
    }

    return stringStatus;
  }
}
